module.exports = __webpack_public_path__ + "img/logo.c75c77ab.jpg";